export default __webpack_public_path__ + "static/media/justBreathe.1f7928e9.png";